import { Pipe, PipeTransform } from '@angular/core';
import { Player } from 'src/models/player.model';

@Pipe({
   name: 'player'
})
export class TournamentPlayerPipe implements PipeTransform {
   constructor() { }
   transform(round: { player: Player, score: string }[], idx: number) {
      if (round === undefined) return "";
      let p = round[idx];
      if (p != null) {
         if (p.player != null) {
           return p.player.getShortName();
         }
      }
      return "";
   }
}
